"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormParent;

var _Editor = require("./Editor");

function useFormParent() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useEditor = (0, _Editor.useEditor)(parent),
      getParent = _useEditor.getParent;

  return getParent();
}